var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-user-chart" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("users_on_campaign")) + "\n    ")
        ],
        1
      ),
      _c("q-table", {
        attrs: {
          data: _vm.rewards_level,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          filter: _vm.filter,
          "row-key": "name",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("q-search", {
                  attrs: {
                    icon: "far fa-search",
                    placeholder: _vm.$t("search"),
                    debounce: 500
                  },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                }),
                _c("div", { staticClass: "col" }),
                _c("q-btn", {
                  attrs: {
                    color: "positive",
                    icon: "fal fa-plus",
                    label: _vm.$t("add_user_to_campaign")
                  },
                  on: {
                    click: function($event) {
                      _vm.show_add_user_to_campaign = true
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t(col.label)) +
                          "\n            "
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { key: "id", attrs: { "auto-width": "", props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.id) +
                          "\n            "
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    { key: "user_full_name", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.user_full_name) +
                          "\n            "
                      )
                    ]
                  ),
                  _c("q-td", { key: "user_email", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.user_email) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "total_earned_points", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.total_earned_points) +
                          "\n            "
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    { key: "user_current_points", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.user_current_points) +
                          "\n            "
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    { key: "reward_level_title", attrs: { props: props } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(props.row.reward_level_title) +
                          "\n            "
                      )
                    ]
                  ),
                  _c("q-td", { key: "campaign", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(props.row.campaign) +
                        "\n            "
                    )
                  ]),
                  _c("q-td", { key: "created_date", attrs: { props: props } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.fDate(props.row.created_date)) +
                        "\n            "
                    )
                  ]),
                  _c(
                    "q-td",
                    { key: "allowed_to_level_up", attrs: { props: props } },
                    [
                      _c(
                        "q-chip",
                        {
                          attrs: {
                            small: "",
                            color: _vm.colorChip(props.row.allowed_to_level_up)
                          }
                        },
                        [_c("i", { staticClass: "far fa-chevron-up" })]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    { key: "actions", attrs: { props: props } },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          color: "primary",
                          icon: "far fa-pencil-alt"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$router.push({
                              name: "users_reward_level",
                              params: { id: props.row.actions }
                            })
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "90vh"
            }
          },
          on: {
            hide: function($event) {
              return _vm.hideShowUserToCampaign()
            }
          },
          model: {
            value: _vm.show_add_user_to_campaign,
            callback: function($$v) {
              _vm.show_add_user_to_campaign = $$v
            },
            expression: "show_add_user_to_campaign"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.hideShowUserToCampaign()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("add_user_to_campaign")) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "q-input",
                        {
                          attrs: {
                            "float-label": _vm.$t("user"),
                            error: _vm.$v.user_id.$error,
                            clearable: ""
                          },
                          on: {
                            input: _vm.$v.user_id.$touch,
                            click: function($event) {
                              return _vm.clearUserCampaign()
                            }
                          },
                          model: {
                            value: _vm.user,
                            callback: function($$v) {
                              _vm.user = $$v
                            },
                            expression: "user"
                          }
                        },
                        [
                          _c("q-autocomplete", {
                            attrs: {
                              "min-characters": 3,
                              "value-field": function(v) {
                                return (
                                  _vm.user.full_name + " - " + _vm.user.email
                                )
                              },
                              separator: ""
                            },
                            on: {
                              search: _vm.searchUser,
                              selected: _vm.selectUser
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("q-select", {
                        attrs: {
                          options: _vm.campaigns,
                          "float-label": _vm.$t("campaign"),
                          error: _vm.$v.campaign.$error
                        },
                        on: { input: _vm.$v.campaign.$touch },
                        model: {
                          value: _vm.campaign,
                          callback: function($$v) {
                            _vm.campaign = $$v
                          },
                          expression: "campaign"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 text-right" },
                    [
                      _c("q-btn", {
                        staticClass: "q-mr-md",
                        attrs: {
                          color: "negative",
                          icon: "fal fa-ban",
                          label: _vm.$t("cancel")
                        },
                        on: {
                          click: function($event) {
                            return _vm.hideShowUserToCampaign()
                          }
                        }
                      }),
                      _c("q-btn", {
                        attrs: {
                          color: "positive",
                          icon: "fal fa-save",
                          label: _vm.$t("save")
                        },
                        on: {
                          click: function($event) {
                            return _vm.addUserToCampaign()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.errorList.length > 0
                    ? _c(
                        "div",
                        { staticClass: "col-12 q-mt-md" },
                        [
                          _c(
                            "q-list",
                            { attrs: { dense: "", separator: "" } },
                            [
                              _c("q-list-header", [
                                _vm._v(_vm._s(_vm.$t("error")))
                              ]),
                              _vm._l(_vm.errorList, function(error, index) {
                                return _c(
                                  "q-item",
                                  { key: index },
                                  [
                                    _c("q-item-main", {
                                      attrs: { label: _vm.$t(error) }
                                    })
                                  ],
                                  1
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }